<template>
  <div class="order-success" v-if="isShowPage">
    <div class="cell-card">
      <div class="success-hd">
        <img class="success-ico" src="../assets/success_ico.png" alt="">
        <div class="success-text">
          <span>活动订单提交成功</span>
        </div>
        <div v-if="hasUnSubmitOrder">
          <span style="display:inline-block;padding-bottom:10px">您的商城意向单中尚有预订未完成</span>
          <div class="goConfirm">
            <span @click="goNextPage">请前往确认</span>
          </div>
        </div>
      </div>
      <OrderCard :payerDisabled="true" submitOrder :initData="$store.state.bindTicket"/>
    </div>
    <div class="cell-card back-home" @click="goHome">返回首页</div>
    <div class="success-btn flex-center-box">
      <van-button class="btn-box btn-linear-gradient" @click="gotoDetail">查看活动订单</van-button>
      <van-button class="btn-box" @click="gotoBindTicket">为其他舱房创建订单</van-button>
    </div>
    <!--二维码弹窗-->
    <!-- <van-popup v-model="show">
      <img class="popImg" :src="qrCode" alt="">
    </van-popup> -->
  </div>
</template>

<script>
import OrderCard from './order_detail/OrderCard'
import api from '@/api'
import { showLoading, hideLoading, showAlert } from '@/utils/tools'
import { checkLoginStatus, toShoppingMall, gioTracking } from '@/plugins/common.js'
export default {
  name: 'PageOrderSuccess',

  components: {
    OrderCard
  },

  data () {
    return {
      hasUnSubmitOrder: false,
      qrCode: '',
      show: false,
      isShowPage: false
    }
  },

  created () {
    checkLoginStatus().then(() => {
      this.getBoookInfo()
      // this.getQrCode()
      this.isShowPage = true
      gioTracking('page.set', 'PCPOrderID', this.$store.state.bindTicket.orderId)
      gioTracking('track','evt_submitSuc')
    })
  },

  methods: {
    goNextPage () {
      toShoppingMall('shoppingCart')
    },
    // 获取订单信息
    async getBoookInfo () {
      showLoading()
      const { errCode, errMsg, data } = await api.getBookingOrderInfo()
      hideLoading()
      if (errCode === 0) {
        this.hasUnSubmitOrder = data.hasUnSubmitOrder
      } else {
        showAlert(errMsg)
      }
    },
    // 获取二维码
    async getQrCode () {
      showLoading()
      const { errCode, errMsg, data } = await api.getQrCode()
      hideLoading()
      if (errCode === 0) {
        this.qrCode = data
        this.show = true
      } else {
        showAlert(errMsg)
      }
    },
    goHome () {
      this.$router.push('/')
    },
    gotoDetail () {
      this.$router.push({
        name: 'PageOrderDetail'
      })
    },
    gotoBindTicket () {
      this.$router.push({
        name: 'bindTicket'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.order-success{
  padding: 30px 50px 130px;
  ::v-deep .order-card{
    border-radius: 0;
  }
  .cell-card{
    border-radius: 8px;
    overflow: hidden;
    background-color: #ffffff;
    text-align: center;
    font-size: 24px;
    margin-bottom: 40px;
  }
  .popImg{
    width: 500px;
    text-align: center;
  }
  .success-hd{
    color: @main-gray2;
    padding: 45px 0;
    border-bottom: 1PX solid @main-gray5;
    .success-ico{
      width: 52px;
      height: 52px;
      margin-bottom: 10px;
    }
    .success-text{
      line-height: 2;
      // margin-bottom: 20px;
      span{
        font-size: 26px;
      }
    }
    .goConfirm{
      color: #1174b8;
      font-size: 30px;
      span{
        display: inline-block;
        border-bottom: 1PX solid #1174b8;
      }
    }
  }
  .back-home{
    padding: 20px 0;
    font-size: 30px;
    color: #1174b8;
  }
  .success-btn{
    .btn-box{
      width: 49%;
      background-color: #1174b8;
      color: #ffffff;
      border-radius: 5px;
      font-size: .3rem;
      padding: 0 .15rem;
    }
    .btn-linear-gradient{
      color: @main-gray2;
    }
  }
}
</style>
